import defaultLanguage from '../../defaultLanguage.js';

import Vue from 'vue'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import zh from './zh.js'
import en from './en.js'
import ja from './ja.js'
import vi from './yn.js'
import zh_TW from './ft.js'
import yin from './yin.js'
import es from './es.js'
import tr from './tr.js'
import fa from './fa.js'
import ml from './ml.js'
import kr from './kr.js'

const messages = {
	en,
    ja,
    vi,
	kr,
    'zh-TW':zh_TW,
	yin,
	es,
	fa,
	tr,
	ml,
	zh,
	
}
let i18nConfig = {
	locale: sessionStorage.getItem('UNI_LOCALE') ?  sessionStorage.getItem('UNI_LOCALE') : defaultLanguage,
	// 获取已设置的语言
	messages
}
const i18n = new VueI18n(i18nConfig)
export default i18n